import { onMounted } from 'vue'
import useGet from '../../../core/composables/api/useGet'
import type { Member } from '@/core/models/member/member'
import type { FeedbackGoalProgress } from '@/modules/coachees/composables/use-coachee-feedback-goal-progress'

export const useFeedbackGoals = () => {
  const { data, status, load } = useGet<FeedbackGoal[]>('task/feedback-goals')

  onMounted(() => {
    load()
  })

  return { feedbackGoals: data, status }
}

export interface FeedbackGoal {
  readonly id: string
  readonly feedbackTopic: { id: string; title: string; icon?: string }
  readonly isActive: boolean
  readonly progress: FeedbackGoalProgress
  readonly coach: Member
}
